import { render, staticRenderFns } from "./AddressedToModal.vue?vue&type=template&id=0c966bd2&scoped=true&"
import script from "./AddressedToModal.vue?vue&type=script&lang=js&"
export * from "./AddressedToModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressedToModal.vue?vue&type=style&index=0&id=0c966bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c966bd2",
  null
  
)

export default component.exports